import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cybersource-authentication-required-modal',
  templateUrl: './cybersource-authentication-required-modal.component.html',
  styleUrls: ['./cybersource-authentication-required-modal.component.css'],
})
export class CybersourceAuthenticationRequiredModalComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
